import React from 'react'

const IcFacebook = ({ className, size = 20 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.333 10C20.333 4.47715 15.8559 0 10.333 0C4.81016 0 0.333008 4.47715 0.333008 10C0.333008 14.9912 3.98984 19.1283 8.77051 19.8785V12.8906H6.23145V10H8.77051V7.79688C8.77051 5.29063 10.2635 3.90625 12.5477 3.90625C13.6414 3.90625 14.7861 4.10156 14.7861 4.10156V6.5625H13.5252C12.283 6.5625 11.8955 7.3334 11.8955 8.125V10H14.6689L14.2256 12.8906H11.8955V19.8785C16.6762 19.1283 20.333 14.9912 20.333 10Z" fill="#98A2B3" />
  </svg>
)

export default IcFacebook
